import React, { useEffect, useState, Fragment } from "react";
import Navbar from "../../tailwindUI/Navbar";
import Heading from "../../tailwindUI/Heading";
import classes from "../../module.css/StmDashboard.module.css";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Transition } from "@headlessui/react";

const CBTNotifications = () => {
  const [loading, setLoading] = useState(false);
  const [notificationLoading, setNotificationLoading] = useState("");
  const [notifications, setNotifications] = useState([]);
  const users = localStorage.getItem("UserToken");

  useEffect(() => {
    Notification();
  }, []);

  const Notification = () => {
    setLoading(true);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/am/CBTRemarkListNotification`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" && result.status_code === 200) {
          setNotifications(Array.isArray(result.data) ? result.data : []);
        } else {
          setNotifications([]);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setNotifications([]);
      })
      .finally(() => setLoading(false));
  };

  const ReadNotification = (id) => {
    setNotificationLoading(id);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", global.authToken);
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      UserToken: users,
      NotificationID: id,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${global.apiBaseUrl}/api/v1/stockone/am/AMNotificationMarkRead`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result.status === "Success" && result.status_code === 200) {
          Notification(); // Refresh the notification list
        }
      })
      .catch((error) => console.log("error", error))
      .finally(() => setNotificationLoading(""));
  };

  return (
    <>
      <Navbar navbarType={"CBT"} />
      <div className="mb-4">
        <Heading headingType={"Page Headings"} headingText={"Notifications"} />
      </div>

      {loading ? (
        <img
          src="../assets/loadingGif.gif"
          alt="loading"
          className={classes.loader}
        />
      ) : (
        <div className={classes.form}>
          {Array.isArray(notifications) && notifications.length > 0 ? (
            <div className="opacity-100 overflow-auto">
              {notifications.map((item) => (
                <div
                  key={item.NotificationID}
                  aria-live="assertive"
                  className="px-4 py-6 sm:p-4"
                >
                  <Transition
                    show={true}
                    as={Fragment}
                    enter="transform ease-out duration-300 transition"
                    enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                    enterTo="translate-y-0 opacity-100 sm:translate-x-0"
                    leave="transition ease-in duration-100"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="pointer-events-auto overflow-hidden rounded-lg bg-amber-200 shadow-lg ring-1 ring-black ring-opacity-5">
                      <div className="p-4">
                        <div className="flex items-center">
                          <div className="ml-3 w-0 flex-1 pt-0.5">
                            <div className="text-sm font-medium text-gray-900">
                              <p>
                                Notification Message-{" "}
                                {item.Massage || "No message"} Date-{" "}
                                {new Date(
                                  item.ScheduleDate
                                ).toLocaleDateString()}
                              </p>
                            </div>
                          </div>
                          <div className="ml-4 flex flex-shrink-0">
                            <button
                              type="button"
                              className="inline-flex rounded-md bg-black text-white hover:text-gray-500 focus:outline-none"
                              onClick={() =>
                                ReadNotification(item.NotificationID)
                              }
                            >
                              <span className="sr-only">Close</span>
                              {notificationLoading === item.NotificationID ? (
                                <div>Loading...</div> // You can replace this with TailSpin if you have it imported
                              ) : (
                                <XMarkIcon
                                  className="h-5 w-5"
                                  aria-hidden="true"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div>
              ))}
            </div>
          ) : (
            <div>No Notifications Available</div>
          )}
        </div>
      )}
    </>
  );
};

export default CBTNotifications;
